import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal, output, OutputEmitterRef } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { QuantityCounterAdapterComponent } from '@libs/form/components';
import { ProductBaseModel, ProductBundleItemModel } from '@libs/shop/models';
import { ProductLabelsComponent } from '../../../catalog';
import { ProductPriceFormatterComponent } from '../../../catalog/product-prices/product-price-formatter';
import { AddToCartSmallElementComponent } from '../../../elements';

@Component({
  selector: 'ui-configurable-bundle-form-item',
  imports: [
    MatCard,
    ProductLabelsComponent,
    ProductPriceFormatterComponent,
    AddToCartSmallElementComponent,
    MatTooltip,
    QuantityCounterAdapterComponent,

  ],
  templateUrl: './configurable-bundle-form-item.component.html',
  styleUrl: './configurable-bundle-form-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleFormItemComponent {
  public item: InputSignal<ProductBundleItemModel> = input.required();
  public isInBundle: InputSignal<boolean> = input.required();
  public isFree: InputSignal<boolean> = input(false);
  public amount: ModelSignal<number> = model.required();
  public showAddToBundle: InputSignal<boolean> = input(true);
  public disabled: InputSignal<boolean> = input(false);
  public position: InputSignal<number> = input.required();
  public maxQuantity: InputSignal<number | undefined> = input();
  public showItemQuantity: InputSignal<boolean> = input(false);
  public enableProductClickTracking: InputSignal<boolean> = input(true);
  public addToBundle: OutputEmitterRef<ProductBaseModel> = output();
  public removeFromBundle: OutputEmitterRef<ProductBaseModel> = output();

  public onAddToBundle(): void {
    if (!this.isInBundle() && !this.disabled()) {
      this.addToBundle.emit(this.item());
    }
  }
}
